import { appLanguage } from "../App";
import i18n from "i18next";

import { initReactI18next } from "react-i18next";

import da_DK from "./da_DK";
import de_DE from "./de_DE";
import en_US from "./en_US";
import es_ES from "./es_ES";
import fr_FR from "./fr_FR";
import hu_HU from "./hu_HU";
import it_IT from "./it_IT";
import lt_LT from "./lt_LT";
import nl_NL from "./nl_NL";
import pl_PL from "./pl_PL";
import pt_BR from "./pt_BR";
import pt_PT from "./pt_PT";
import ro_RO from "./ro_RO";
import ru_RU from "./ru_RU";
import sk_SK from "./sk_SK";
import sl_SI from "./sl_SI";
import sv_SE from "./sv_SE";
import tr_TR from "./tr_TR";
import vi_VN from "./vi_VN";
import zh_CN from "./zh_CN";

//noinspection JSIgnoredPromiseFromCall
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    ns: ["translation"], //important to overwrite the default ns of cpq
    defaultNS: "translation",
    debug: true,
    lng: appLanguage ? appLanguage : "en_US",
    //fallbackLng: "cimode",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      de: de_DE,
      "de-DE": de_DE,
      en: en_US,
      "en-US": en_US,
      es: es_ES,
      "es-ES": es_ES,
      da: da_DK,
      "da-DK": da_DK,
      fr: fr_FR,
      "fr-FR": fr_FR,
      hu: hu_HU,
      "hu-HU": hu_HU,
      it: it_IT,
      "it-IT": it_IT,
      lt: lt_LT,
      "lt-LT": lt_LT,
      nl: nl_NL,
      "nl-NL": nl_NL,
      pl: pl_PL,
      "pl-PL": pl_PL,
      pt: pt_BR,
      "pt-BR": pt_BR,
      "pt-PT": pt_PT,
      ro: ro_RO,
      "ro-RO": ro_RO,
      ru: ru_RU,
      "ru-RU": ru_RU,
      sk: sk_SK,
      "sk-SK": sk_SK,
      sl: sl_SI,
      "sl-SI": sl_SI,
      sv: sv_SE,
      "sv-SE": sv_SE,
      tr: tr_TR,
      "tr-TR": tr_TR,
      vi: vi_VN,
      "vi-VN": vi_VN,
      zh: zh_CN,
      "zh-CN": zh_CN,
    },
  });

export default i18n;
